<template>
  <div class="chat-input">
    <div class="input-container">
      <input
        v-model="newMessage"
        type="text"
        placeholder="Type your message..."
        class="message-input"
        :disabled="isLoading"
        @keyup.enter="sendMessage"
      />
      <button class="send-btn" :disabled="!newMessage.trim() || isLoading || !acceptedTerms" @click="sendMessage">
        <svg
          v-if="!isLoading"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22,2 15,22 11,13 2,9"></polygon>
        </svg>
        <span v-else class="loading-spinner"></span>
      </button>
    </div>
    <div v-if="!acceptedTerms" class="accept-terms">
      <p>You must accept the terms below to use the KBuddy chat</p>
      <label>
        <input id="acceptTerms" v-model="acceptedTerms" type="checkbox" />
        I accept that metrics from the use of this chatbot will be used to help improve KBuddy. No personally
        identifiable information is collected.
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IChatMessage, IChatRequest, IChatResponse } from "../interfaces/chatBotInterfaces";
import { useChatBotStore } from "../stores/chatBotStore";

import { ref } from "vue";
import { formatChatMessage } from "format-chat-message";
import { chatBotApi } from "@/common";
import { IAnswer } from "../interfaces/chatBotInterfaces";

const newMessage = ref("");
const isLoading = ref(false);
const acceptedTerms = ref(false);
const chatBotStore = useChatBotStore();

function copyStringWithoutReference(text: string) {
  return (" " + text).slice(1);
}

const sendMessage = async () => {
  if (!newMessage.value.trim() || isLoading.value) return;
  const question = copyStringWithoutReference(newMessage.value.trim());
  newMessage.value = "";

  const userMessage: IChatMessage = {
    id: Date.now().toString(),
    type: "user",
    text: question,
    timestamp: new Date(),
  };

  chatBotStore.messages.push(userMessage);

  // Simulate bot response
  isLoading.value = true;

  const response = await ask(question);
  const botMessage: IChatMessage = {
    id: response.assistantMessageId.toString(),
    type: "bot",
    text: response.answer,
    timestamp: new Date(),
  };
  chatBotStore.messages.push(botMessage);
  isLoading.value = false;
};

async function ask(question: string): Promise<IAnswer> {
  try {
    const request = {
      sessionId: chatBotStore.sessionId,
      message: question,
      brand: "Safe",
    } as IChatRequest;

    const response = (await chatBotApi.ask(request)).data as IChatResponse;
    chatBotStore.setSessionId(response.entity.data.sessionId);
    console.log(chatBotStore.sessionId);

    return {
      sessionId: response.entity.data.sessionId,
      assistantMessageId: response.entity.data.assistantMessageId,
      answer: formatChatMessage({ message: response.entity.data.answer }) || "No response from bot.",
      sources: [],
    };
  } catch (error) {
    console.error("Error fetching token:", error);
    return {
      sessionId: chatBotStore.sessionId,
      assistantMessageId: 0,
      answer: "Error Error. Does not compute", // Rethrow the error after logging it
      sources: [],
    };
  }
}
</script>
